import './productTile.scss';

const lazyLoad = function lazyLoadProductTile(el) {
  [].forEach.call(
    el.querySelectorAll('[data-src]'),
    (source) => {
      source.setAttribute('src', source.getAttribute('data-src'));
      source.removeAttribute('data-src');
    },
  );
  [].forEach.call(
    el.querySelectorAll('[data-srcset]'),
    (source) => {
      source.setAttribute('srcset', source.getAttribute('data-srcset'));
      source.removeAttribute('data-srcset');
    },
  );
};

const render = function renderProductTile({ tile, swatch, url }) {
  [].forEach.call(
    tile.querySelectorAll('.js-productTileImage'),
    (el) => {
      if (el.getAttribute('data-variant') === swatch) {
        el.classList.add('is-selected');
        lazyLoad(el);
      } else {
        el.classList.remove('is-selected');
      }
    },
  );

  [].forEach.call(
    tile.querySelectorAll('.js-productTileSwatch'),
    (el) => {
      if (el.getAttribute('data-swatch') === swatch) {
        el.parentNode.classList.add('is-selected');
      } else {
        el.parentNode.classList.remove('is-selected');
      }
    },
  );

  [].forEach.call(
    tile.querySelectorAll('.js-productTileLink'),
    (el) => {
      el.setAttribute('href', url);
    },
  );
};

const onSwatchClick = function onProductTileSwatchClick(ev) {
  ev.preventDefault();
  const swatch = ev.currentTarget.getAttribute('data-swatch');
  const tile = ev.currentTarget.parentNode.parentNode.parentNode.parentNode;
  const url = ev.currentTarget.getAttribute('href');

  render({ tile, swatch, url });
};

const bind = function bindProductTile(props = {}) {
  const { shouldUnbind } = props;
  const method = shouldUnbind ? 'removeEventListener' : 'addEventListener';

  [].forEach.call(
    document.querySelectorAll('.js-productTileSwatch'),
    el => el[method]('click', onSwatchClick),
  );
};

const destroy = function destroyProductTile() {
  bind({ shouldUnbind: true });
};

const init = function initProductTile() {
  bind();
};

export default {
  destroy,
  init,
};
